<template>
  <CustomHeaderModal
    :isShowModal="isShowModal"
    @cancel="cancel">
    <!-- ヘッダー -->
    <header class="card-header">
      <div class="cover-filter">
        <p class="card-header-title">
          ルーム
        </p>
      </div>
    </header>
    <!-- 詳細 メイン -->
    <template v-if="modalRoomIndex === 0">
      <div class="create-menu">
        <div class="-body  disp-scroll">
          <h2 class="-title">
            ルームを作成する
          </h2>
          <div class="input-box">
            <p class="-label">ルーム名</p>
            <input class="input -right-box" maxlength="100" v-model="createRoom.name"/>
          </div>
          <div class="input-box">
            <p class="-label">公開・非公開</p>
            <select class="select -right-box" v-model="createRoom.type">
              <option
                v-for="(cat, idx) in category"
                :key="idx"
                :value="idx">
                {{cat}}
              </option>
            </select>
          </div>
          <div class="input-box">
            <p class="-label">参加メンバー</p>
            <b-taginput
              v-model="createRoom.user"
              :data="userList"
              :allow-new="false"
              :open-on-focus="true"
              field="name"
              autocomplete
              class="-right-box"
              icon="label"
              placeholder="メンバーを一人以上追加してください。">
            </b-taginput>
          </div>
        </div>
        <div class="footer-box">
          <button class="button nav-button" @click="cancel()">
            キャンセル
          </button>
          <button class="button is-primary" @click="createChatRoom()">
            作成する
          </button>
        </div>
      </div>
    </template>
  </CustomHeaderModal>
</template>

<script>
import CustomHeaderModal  from '@/components/Modals/CustomHeaderModal'
export default {
  components: {
    CustomHeaderModal,
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    userList: {
      type: Array,
      required: true
    },
    modalRoomIndex: {
      type: Number,
      required: true
    },
  },
  data () {
    return {
      createRoom: {
        name: '',
        type: 0,
        user: [],
        company: this.user.companyPK
      },
      category: ['公開', '非公開']
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    createChatRoom () {
      if (this.createRoom.name.length <= 0) {
        alert('ルーム名を一文字以上入力してください。')
        return
      }
      if (this.createRoom.user.length <= 0) {
        alert('ルーム参加者が自分を除いて0人のため、1人以上増やしてください。')
        return
      }
      // hashのみにする
      this.createRoom.user = this.$_.map(this.createRoom.user, this.$_.property('user_hash'))
      this.createRoom.user.push(this.user.userHash)
      this.$emit('createChatRoom', this.createRoom)
      this.createRoom = {
        name: '',
        type: 0,
        user: [],
        company: this.user.companyPK
      }
      this.cancel()
    }
  }
}
</script>

<style lang="scss" scoped>
.cover-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .card-header-title {
    font-size: 24px;
    font-weight: 600;
  }
  .nav-button {
    color: #a22;
    border: solid 2px #a22;
    font-weight: 800;
  }
  div {
    display: flex;
    button {
      margin: 8px;
    }
  }
}

.create-menu {
  width: 100%;
  padding: 24px;
  //overflow-y: scroll;
  .-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  .-body {
    width: 100%;
    .input-box {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 8px;
      .-label {
        width: 200px;
        font-weight: 600;
        text-align: left;
      }
      .-right-box {
        width: calc(100% - 200px);
        text-align: left;
      }
    }
  }
  .footer-box {
    border-top: solid thin #ccc;
    width: 100%;
    margin-top: 32px;
    padding: 16px;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      width: 30%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VirtualOffice/organisms/ModalRoom.vue